import "../styles/AuthLayout.css"; // ✅ FIXED PATH
import bgImage from "../assets/companylogo.png"; // same bg as login

const AuthLayout = ({ children }) => {
  return (
    <div
      className="auth-page"
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      <div className="auth-overlay"></div>

      <div className="auth-center">
        {children}
      </div>
    </div>
  );
};

export default AuthLayout;
